import {
  AnswerOption,
  Cards,
  CourseChapter,
  CourseModuleCards,
  Question,
} from "@mikros/library";
import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@progress/kendo-react-buttons";
import { Error } from "@progress/kendo-react-labels";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "../alert";
import { useIntl } from "react-intl";
import {
  Sortable,
  SortableItemUIProps,
  SortableOnDragOverEvent,
  SortableOnNavigateEvent,
} from "@progress/kendo-react-sortable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Tooltip, Whisper } from "rsuite";
import { Switch } from "@progress/kendo-react-inputs";
import {
  CardComponent,
  CardComponentProps,
} from "../courseModuleChapters/cardComponent";
import { MenuOptions } from "../menuOptions";
import { AssementCard } from "../courseModuleChapters/assementCard";
import Utils from "../utils";
import { Loading } from "../loading";

export interface GeneratedChapterEditProps {
  getIndex: (chptId: string) => number;
  chapter: CourseChapter;
  handleDelChapter: (chapter: CourseChapter) => void;
  course: CourseModuleCards;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  handleVideoGeneration: (e: any) => Promise<string | false>;
  handleImageGeneration: (e: any) => Promise<string | false>;
  // handleAudioGeneration: (e: any) => Promise<string | false>;
  handleAudioGeneration?: (
    e: any
  ) => Promise<{ presignedUrl: string; prompt: string } | false>;
  handleUpdateChapter: (e: CourseChapter, isSave: boolean) => void;
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  videoGeneratingCardIds: Set<string>;
  setVideoGeneratingCardIds: (cardId: string | null) => void;
  handleFileTypeUpdate?: (cardId: string, fileType: string) => void;
  handleCardTypeUpdate?: (cardId: string, newCardType: string) => void;
  specificCreateCourseFunction?: (
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll?: (status: string, course: CourseModuleCards) => void;
  clickSaveValue?: boolean;
  // onQuickSaveSuccess?:()=>void
  onQuickSaveSuccess?: (savedCourse: CourseModuleCards) => void;
  copyCourse?: any;
}

export function GeneratedChapterEdit(props: GeneratedChapterEditProps) {
  const intl = useIntl();
  const [aIVideoGenerating, setAIVideoGenerating] = useState<boolean>(false);

  const delChapter = (
    <Tooltip className="bg-mk-primary text-black " style={{ zIndex: 99999 }}>
      <div>
        {`${intl.formatMessage({
          id: "courses.generateChapterEdit.deleteChapter",
        })}`}
      </div>
    </Tooltip>
  );
  const addNewCard = (
    <Tooltip
      className="bg-mk-primary text-black"
      style={{ zIndex: 99999 }}
      visible
      onClick={(event: any) => {
        event.stopPropagation();
      }}
    >
      <div>
        {/* Add a new Card */}
        {`${intl.formatMessage({
          id: "courses.generateChapterEdit.addNewCard",
        })}`}
      </div>
    </Tooltip>
  );

  const addNewAsmnt = (
    <Tooltip
      className="bg-mk-primary text-black"
      style={{ zIndex: 99999 }}
      visible
      onClick={(event: any) => {
        event.stopPropagation();
      }}
    >
      <div>
        {/* Add a new Question */}
        {`${intl.formatMessage({
          id: "courses.generateChapterEdit.addNewQuestion",
        })}`}
      </div>
    </Tooltip>
  );

  const addOption = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-bars-sort" as IconName]}
          className="fa-fa w-4 h-4 rotate-180 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({
        id: "courses.generateChapterEdit.textLabel",
      }),
      value: "TEXT",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-image" as IconName]}
          className="fa-fw w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({
        id: "courses.generateChapterEdit.imageLabel",
      }),
      value: "IMG",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-file-video" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({
        id: "courses.generateChapterEdit.videoLabel",
      }),
      value: "VIDEO",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-music" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({
        id: "courses.generateChapterEdit.audioLabel",
      }),
      value: "AUDIO",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-link" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({
        id: "courses.generateChapterEdit.linkLabel",
      }),
      value: "LINK",
    },
  ];

  console.log(
    "This is the chapter data when editing =>",
    JSON.stringify(props.chapter)
  );

  // Log URL fields from chapter cards
  if (props.chapter?.cards) {
    props.chapter.cards.forEach((card: any, index: number) => {
      console.log(`Chapter Card ${index + 1} URL field:`, {
        cardId: card.cardId,
        url: card.url,
        cardInfo: card.cardInfo,
        cardType: card.cardType,
      });
      console.log(`Chapter Card ${index + 1} presigned url:`, card.url);
    });
  }

  // Log the outermost presigned URLs from all chapter cards
  console.log(
    "OUTERMOST PRESIGNED URLS:",
    props.chapter?.cards?.map((card) => card.url).filter((url) => url)
  );
  let utils = new Utils();

  const containerRef = React.useRef<HTMLDivElement>(null);
  const containerLeft = React.useRef<HTMLDivElement>(null);

  console.log(
    "Ai video generating inside generated chapter edit",
    aIVideoGenerating
  );

  const scrollToLast = () => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const chapterSpeaker = (
    <Tooltip className="bg-mk-primary text-black " style={{ zIndex: 99999 }}>
      <div>{`${intl.formatMessage({
        id: "courses.generateChapterEdit.enterChapterName",
      })}`}</div>
    </Tooltip>
  );

  const scrollToLeft = () => {
    if (containerLeft.current) {
      console.log("inside scroll to left function");
      containerLeft.current.scrollLeft =
        containerLeft.current.scrollWidth * containerLeft.current.scrollWidth;
    }
  };

  const [initialChptCard, setInitialChptCard] = useState<CourseChapter>(
    utils.deepCopy(props.chapter) as CourseChapter
  );
  const [chaptCards, setChaptCards] = useState<CourseChapter>(props.chapter);
  const chapterNameRef = useRef<HTMLDivElement>(null);
  const [toggle, setToggle] = useState<boolean>(false);
  const [chptNameEdit, setChptNameEdit] = useState<boolean>(false);
  const [cardArray, setCardArray] = useState<Array<object>>(chaptCards.cards);
  const [enableDrag, setEnableDrag] = useState<boolean>(true);
  const [showNoExistingQuestionDialog, setShowNoExistingQuestionDialog] =
    useState<boolean>(false);

  //for scroll useState
  const [scrollFlag, setScrollFlag] = useState<boolean>(false);
  const [firstTime, setFirstTime] = React.useState<number>(0);

  //errors
  const [errors, setErrors] = useState<any>({});
  const [showDialog, setShowDialog] = React.useState<boolean>(false);
  const [showLinkValidation, setLinkValidation] =
    React.useState<boolean>(false);
  const [showSizeError, setSizeError] = React.useState<boolean>(false);
  const [fileSizeDailog, setfileSizeDailog] = React.useState<boolean>(false);
  const [largeFileSizeDialog, setLargeFileSizeDialog] =
    React.useState<boolean>(false);
  const [formUserDialog, setFormUserDialog] = React.useState<boolean>(false);
  const [fileSizeImageValidation, setFileSizeImageValidation] =
    React.useState<boolean>(false);

  const [questionOptionsDialog, setQuestionOptionsDialog] =
    React.useState<boolean>(false);
  const [emptyQuestionsDialog, setEmptyQuestionsDialog] =
    useState<boolean>(false);
  const [emptyOptionsDialog, setEmptyOptionsDialog] =
    React.useState<boolean>(false);
  const [isSave, setIsSave] = useState<boolean>(false);
  console.log("print save adfadfdfsdfsfdsdsaf ", isSave);

  //loader for duplicate and media upload cards
  const [loader, setLoader] = React.useState<boolean>(false);

  // Quick save related state
  const [copyCourse, setCopyCourse] = useState<CourseModuleCards | null>(null);

  // Helper function to check if any card has dummyTempUrl

  const getObjectNotFoundUrl = (chapter: CourseChapter): boolean => {
    for (const card of chapter.cards || []) {
      const cardUrl = card.url;
      console.log(
        "card url inside get object not found url of generatedChapterEdit print pleaseeeee",
        cardUrl
      );

      if (cardUrl === "" || cardUrl?.includes("object not found")) {
        // if (cardUrl?.includes("object not found")) {
        return true;
      }
    }
    return false;
  };

  // Check if this chapter has dummyTempUrl
  // const hasDummyUrl = hasDummyTempUrl(chaptCards);
  const hasEmptyUrl = getObjectNotFoundUrl(chaptCards);
  console.log(
    "chapter name print in generatedChapterEdit",
    chaptCards.chapterName
  );

  console.log("has empty url inside generatedChapterEdit", hasEmptyUrl);

  console.log(
    "card data temp url inside generatedChapterEdit for chapter",
    chaptCards.chapterId,
    chaptCards.cards?.[0]?.cardInfo?.card?.[0]?.url,
    "Has dummyTempUrl print pleaseeee:",
    getObjectNotFoundUrl
  );

  console.log("card array in generate chapter edit", cardArray);
  console.log("chapter card question", chaptCards.questions);

  console.log(
    "chapter card question ids",
    chaptCards.questions?.map((quest: any) => quest.quesId)
  );

  console.log(
    "chapter card questions in generate chapter answer options edit",
    chaptCards.questions?.map((ansOption: any) => {
      ansOption?.answerOptions;
    })
  );

  const okClick = () => {
    setFormUserDialog(false);
  };

  const okfileSizeClick = () => {
    setfileSizeDailog(false);
  };

  const oklargeFileSizeClick = () => {
    setLargeFileSizeDialog(false);
  };

  const okquestionClick = () => {
    setQuestionOptionsDialog(false);
  };
  const emptyquestionClick = () => {
    setEmptyQuestionsDialog(false);
  };
  const emptyoptionClick = () => {
    setEmptyOptionsDialog(false);
  };

  const handleUpdateChapterName = (e: React.FormEvent<HTMLDivElement>) => {
    setChptNameEdit(true);
    console.log("entered handle update chapter name");
    const element = e.currentTarget;
    const text = element.textContent || "";

    if (text.trim() === "") {
      element.innerHTML = "";
    }

    let dt = chaptCards;
    dt.chapterName = text;
    if (e.currentTarget.textContent) {
      dt.chapterName = e.currentTarget.textContent;
      setChaptCards(dt);
    }
  };

  const onDragOver = (event: SortableOnDragOverEvent) => {
    console.log("This is drag over", event.newState);

    setCardArray(event.newState);
  };

  const onNavigate = (event: SortableOnNavigateEvent) => {
    console.log("This is navigate", event.newState);
    setCardArray(event.newState);
  };

  // const handleAddNewCard = (cardType: any) => {
  //   setScrollFlag(true);

  //   let dt = chaptCards;
  //   let date = new Date();
  //   let newCardId = uuidv4();

  //   // Determine fileType based on cardType
  //   let fileType = "";
  //   if (cardType === "IMG") {
  //     fileType = "png";
  //   } else if (cardType === "VIDEO") {
  //     fileType = "mp4";
  //   } else if (cardType === "TEXT") {
  //     fileType = "txt";
  //   } else {
  //     fileType = cardType; // fallback to cardType if unknown
  //   }

  //   let newCard: Cards = {
  //     isLastCard: false,
  //     seqNo: dt.cards.length + 1,
  //     entityId: dt.entityId,
  //     status: dt.status,
  //     createdAt: date.toISOString(),
  //     cardType: cardType,
  //     createdBy: "LOCAL TEST",
  //     cardId: newCardId,
  //     chapterId: dt.chapterId,
  //     date: date.toISOString(),
  //     chapterName: dt.chapterName,
  //     courseName: dt.courseName,
  //     recType: dt.recType,
  //     updatedAt: date.toISOString(),
  //     courseId: dt.courseId,
  //     description: dt.description,
  //     entryType: "CARD",
  //     cardInfo: {
  //       cardType: cardType,
  //       card: [
  //         {
  //           language: "ENGLISH",
  //           text: "",
  //           fileType: fileType,
  //           url: "",
  //           tempUrl: "",
  //         },
  //       ],
  //       cardId: newCardId,
  //     },
  //     cardName:
  //       intl.formatMessage({ id: "cardLang" }) +
  //       (dt.cards.length + 1).toString(),
  //   };
  //   dt.cards.push(newCard);

  //   setChaptCards(dt);
  //   setCardArray(dt.cards);
  //   console.log("Setting the cards");
  //   scrollToLast();
  // };

  const handleAddNewCard = (cardType: any) => {
    setScrollFlag(true);

    // Use the current cardArray (which reflects the latest UI order) instead of chaptCards.cards
    const currentCards: Cards[] = Array.isArray(cardArray)
      ? [...(cardArray as Cards[])]
      : [];
    const date = new Date();
    const newCardId = uuidv4();

    // Determine fileType based on cardType
    let fileType = "";
    if (cardType === "IMG") {
      fileType = "png";
    } else if (cardType === "VIDEO") {
      fileType = "mp4";
    } else if (cardType === "TEXT") {
      fileType = "txt";
    } else {
      fileType = cardType; // fallback to cardType if unknown
    }

    const newCard: Cards = {
      isLastCard: false,
      seqNo: currentCards.length + 1,
      entityId: chaptCards.entityId,
      status: chaptCards.status,
      createdAt: date.toISOString(),
      cardType: cardType,
      createdBy: "LOCAL TEST",
      cardId: newCardId,
      chapterId: chaptCards.chapterId,
      date: date.toISOString(),
      chapterName: chaptCards.chapterName,
      courseName: chaptCards.courseName,
      recType: chaptCards.recType,
      updatedAt: date.toISOString(),
      courseId: chaptCards.courseId,
      description: chaptCards.description,
      entryType: "CARD",
      cardInfo: {
        cardType: cardType,
        card: [
          {
            language: "ENGLISH",
            text: "",
            fileType: fileType,
            url: "",
            tempUrl: "",
          },
        ],
        cardId: newCardId,
      },
      cardName:
        intl.formatMessage({ id: "cardLang" }) +
        (currentCards.length + 1).toString(),
    };

    // Add the new card to the end of the current UI order
    const updatedCards: Cards[] = [...currentCards, newCard];

    // Update seqNo for all cards to reflect their order
    updatedCards.forEach((card, idx) => {
      (card as Cards).seqNo = idx + 1;
    });

    // Update chaptCards immutably, ensuring cards is Cards[]
    const updatedChaptCards = {
      ...chaptCards,
      cards: updatedCards,
    };

    setChaptCards(updatedChaptCards);
    setCardArray(updatedCards);
    console.log("Setting the cards");
    scrollToLast();
  };

  const handleUpdCardContentOfChpt = (cardId: string, content?: string) => {
    console.log("content log", content);
    let dts = chaptCards;
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (content) {
      if (dts.cards[i]) {
        dts.cards[i].cardInfo.card[0].text = content;
      }
    }
    setChaptCards(dts);
  };

  const handleCardImageUpdate = (cardId: string, imageUrl?: any) => {
    console.log("entered handle image card");
    console.log("image url in upload image", imageUrl);

    console.log("print card id", cardId);

    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    console.log("value of i", i);
    if (imageUrl) {
      console.log(
        "print the url in handle image update",
        dts.cards[i].cardInfo.card[0].url
      );
      if (dts.cards[i])
        if (dts.cards[i] && dts.cards[i].cardId === cardId) {
          console.log("set the image url");
          dts.cards[i].cardInfo.card[0].tempUrl = imageUrl;
          dts.cards[i].url = imageUrl;
          console.log("inside the check for i", i);
          console.log(
            dts.cards[i].cardInfo.card[0].tempUrl,
            "inside image url card data"
          );
        }
    }
    setChaptCards(dts);
    setCardArray(dts.cards);
  };

  const getIndex = (cardId: string): number => {
    const arr = cardArray as Cards[];
    const index = arr.findIndex((ele) => ele.cardId === cardId);
    return index + 1;
  };

  const handleCardVideoUpdate = (cardId: string, videoUrl?: any) => {
    console.log("video url in upload video", videoUrl);

    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (videoUrl) {
      console.log("print the url", dts.cards[i].cardInfo.card[0].url);
      if (dts.cards[i]) {
        console.log("set the video url");
        dts.cards[i].cardInfo.card[0].tempUrl = videoUrl;
        dts.cards[i].url = videoUrl;
        console.log(
          dts.cards[i].cardInfo.card[0].tempUrl,
          "inside video url card data"
        );
      }
    }
    setChaptCards(dts);
    setCardArray(dts.cards);
  };

  // const handleGenAudioUrl = (cardId: string, url: any) => {
  //   console.log("url in handle gen audio url generated chapter edit", url);
  //   let dts = { ...chaptCards };
  //   const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
  //   if (url) {
  //     if (dts.cards[i]) {
  //       dts.cards[i].cardInfo.card[0].url = url;
  //     }
  //   }
  // };

  const handleGenAudioUrl = (
    cardId: string,
    url: any,
    completeCardData?: any
  ) => {
    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (dts.cards[i]) {
      if (completeCardData) {
        // Use the complete card data that includes language
        dts.cards[i] = completeCardData;
      } else {
        // Fallback to just updating URL (preserve existing logic)
        dts.cards[i].cardInfo.card[0].url = url;
      }
    }
    setChaptCards(dts);
  };

  const handleGenVideoUrl = (cardId: string, url: any, presignedUrl: any) => {
    console.log("url in handle gen video url generated chapter edit", url);
    console.log(
      "presigned url in handle gen video url generated chapter edit",
      presignedUrl
    );
    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (url) {
      if (dts.cards[i]) {
        dts.cards[i].cardInfo.card[0].url = url;
        dts.cards[i].url = presignedUrl;
      }
    }
  };

  const handleGenImageUrl = (cardId: string, url: any) => {
    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (url) {
      if (dts.cards[i]) {
        dts.cards[i].cardInfo.card[0].url = url;
      }
    }
  };

  const handleCardAudioUpdate = (cardId: string, audioUrl?: any) => {
    console.log("audio url in upload audio", audioUrl);

    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (audioUrl) {
      console.log("print the url", dts.cards[i].cardInfo.card[0].url);
      if (dts.cards[i]) {
        console.log("set the audio url");
        dts.cards[i].cardInfo.card[0].tempUrl = audioUrl;
        dts.cards[i].url = audioUrl;
        console.log(
          dts.cards[i].cardInfo.card[0].tempUrl,
          "inside audio url card data"
        );
      }
    }
    setChaptCards(dts);
    setCardArray(dts.cards);
  };

  const handleCardTypeUpdate = (cardId: string, newCardType: string) => {
    console.log("updating card type", cardId, newCardType);

    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (dts.cards[i]) {
      console.log("setting card type to", newCardType);
      dts.cards[i].cardType = newCardType;
      dts.cards[i].cardInfo.cardType = newCardType;
      // Don't overwrite fileType with cardType - preserve the actual file extension
      // dts.cards[i].cardInfo.card[0].fileType = newCardType;

      // Clear all existing media file contents when converting between media types
      // This prevents old file references from persisting when converting card types
      if (["IMG", "VIDEO", "AUDIO"].includes(newCardType)) {
        dts.cards[i].cardInfo.card[0].tempUrl = "";
        dts.cards[i].cardInfo.card[0].url = "";
        dts.cards[i].url = "";
        dts.cards[i].fileSize = undefined;
        (dts.cards[i] as any).fileCardName = undefined; // Clear fileCardName for AI generated content
      }

      console.log("updated card data", dts.cards[i]);
    }
    setChaptCards(dts);
    setCardArray(dts.cards);
  };

  const handleFileTypeUpdate = (cardId: string, fileType: string) => {
    console.log("File type update requested:", cardId, fileType);

    let dts = { ...chaptCards };
    const i = chaptCards.cards.findIndex((ex) => ex.cardId === cardId);
    if (dts.cards[i]) {
      // Set fileType based on fileType argument or card type
      let newFileType = fileType;
      if (!fileType || fileType === "") {
        // If fileType is not provided, infer from cardType
        const cardType = dts.cards[i].cardType;
        if (cardType === "TEXT") {
          newFileType = "txt";
        } else if (cardType === "IMG") {
          newFileType = "png";
        } else if (cardType === "VIDEO") {
          newFileType = "mp4";
        }
      }
      dts.cards[i].cardInfo.card[0].fileType = newFileType;
      console.log("updated fileType for card", cardId, "to", newFileType);
    }
    setChaptCards(dts);
    setCardArray(dts.cards);
  };

  const handleRemoveCard = (e: string) => {
    let dt = chaptCards;
    let card: Cards[] = [];

    dt.cards.map((ele) => {
      if (ele.cardId !== e) {
        card.push(ele);
      }
    });

    dt.cards = card;
    setChaptCards(dt);
    setCardArray(dt.cards);
  };

  // Helper to determine if duplicate should be disabled for a card (IMG/VIDEO with empty url and tempUrl)
  const isDuplicateDisabled = (card: Cards) => {
    const cardType = card?.cardType;
    const cardUrl = card?.cardInfo?.card?.[0]?.url;
    const cardTempUrl = card?.cardInfo?.card?.[0]?.tempUrl;
    return (
      (cardType === "IMG" || cardType === "VIDEO") &&
      (!cardUrl || cardUrl === "") &&
      (!cardTempUrl || cardTempUrl === "")
    );
  };

  // The duplicate handler now prevents duplication for media cards with no url/tempUrl
  const hanndleDuplicateCard = async (cardId: string) => {
    setScrollFlag(true);
    setLoader(true);

    const dt = { ...chaptCards };
    const originalCard = dt.cards.find((ele) => ele.cardId === cardId);

    if (!originalCard || isDuplicateDisabled(originalCard)) {
      setLoader(false);
      return;
    }

    const index = dt.cards.findIndex((ele) => ele.cardId === cardId);
    const newCardId = uuidv4();
    const cardUrl = originalCard?.cardInfo?.card?.[0]?.url;
    const cardTempUrl = originalCard?.cardInfo?.card?.[0]?.tempUrl;

    let newUrl = "";
    let newPresignedUrl = "";

    if (cardUrl) {
      // Extract file extension properly - get the last part after the last dot
      // This handles cases where filename might be "cardId.cardId.ext" or "cardId.ext"
      const urlWithoutQuery = cardUrl.split("?")[0];
      const filename = urlWithoutQuery.split("/").pop() || "";
      const fileExtension = filename.split(".").pop() || "";
      const newFileName = `${newCardId}.${fileExtension}`;
      newUrl = `Mikros-Cards/acct-${props.course.accntId}/crse-${props.course.courseId}/chptr-${chaptCards.chapterId}/card-${newCardId}/${newFileName}`;
      console.log("Duplicate card (generatedChapterEdit)", {
        originalUrl: cardUrl,
        urlWithoutQuery,
        filename,
        fileExtension,
        newFileName,
        newUrl,
      });
      const duplicatedFile = await props.duplicateS3File(
        cardUrl,
        newUrl,
        originalCard.cardInfo.card[0].fileType
      );
      newPresignedUrl = duplicatedFile !== undefined ? duplicatedFile : "";
    } else if (cardTempUrl) {
      newUrl = cardTempUrl;
      newPresignedUrl = cardTempUrl;
    }

    setLoader(false);

    const date = new Date().toISOString();
    const duplicateCard: Cards = {
      ...originalCard,
      isLastCard: false,
      seqNo: dt.cards.length + 1,
      createdAt: date,
      cardId: newCardId,
      date,
      updatedAt: date,
      cardInfo: {
        cardType: originalCard.cardType,
        card: [
          {
            language: "ENGLISH",
            text: originalCard.cardInfo.card[0].text,
            fileType: newUrl ? newUrl.split(".").pop() || "txt" : "txt",
            url: newUrl || "",
          },
        ],
        cardId: newCardId,
      },
      cardName: `${intl.formatMessage({ id: "cardLang" })}${
        dt.cards.length + 1
      }`,
      url: newPresignedUrl,
    };

    dt.cards.splice(index + 1, 0, duplicateCard);
    setChaptCards(dt);
    setCardArray(dt.cards);
    scrollToLast();
  };

  const handleAddNewQuestion = () => {
    const date = new Date().toISOString();

    // Create base question template
    const createQuestionTemplate = (): Question => ({
      chapterId: chaptCards.chapterId,
      courseId: chaptCards.courseId,
      answer: "",
      createdBy: "",
      date,
      entityId: chaptCards.entityId,
      difficultyLevel: intl.formatMessage({ id: "mediumLang" }),
      quesId: uuidv4(),
      entryType: "QUESTION",
      updatedAt: date,
      quesType: "MCQ",
      recType: "Question_" + uuidv4(),
      question: undefined,
      status: "DRAFT",
      answerOptions: [],
    });

    // Create answer options template
    const createAnswerOptions = (): AnswerOption[] => {
      return ["A", "B", "C", "D"].map((label) => ({
        optionLabel: label,
        optionFlag: "INCORRECT",
        optionVal: undefined,
        optionId: uuidv4(),
        optionRationale:
          "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat maiores quasi recusandae itaque. Quo numquam a excepturi assumenda magnam, hic soluta quisquam culpa non ut impedit beatae voluptatibus obcaecati veritatis.",
      }));
    };

    // If no questions exist, add first question without validation
    if (!chaptCards.questions?.length) {
      const newQuestion = {
        ...createQuestionTemplate(),
        answerOptions: createAnswerOptions(),
      };

      setChaptCards((prev) => ({
        ...prev,
        questions: [...(prev.questions || []), newQuestion],
      }));
      setScrollFlag(true);
      scrollToLast();
      return;
    }

    // Validation checks for existing questions
    const validationChecks = [
      {
        condition: (quest: Question) => !quest.question?.trim(),
        action: () => setEmptyQuestionsDialog(true),
      },
      {
        condition: (quest: Question) =>
          quest.answerOptions?.some((opt) => !opt.optionVal?.trim()),
        action: () => setEmptyOptionsDialog(true),
      },
      {
        condition: (quest: Question) =>
          !quest.answerOptions?.some((opt) => opt.optionFlag === "CORRECT"),
        action: () => setQuestionOptionsDialog(true),
      },
    ];

    let hasValidationErrors = false;

    validationChecks.forEach((check) => {
      const invalidQuestions = chaptCards.questions?.filter(check.condition);
      if (invalidQuestions?.length) {
        invalidQuestions.forEach((q) => (q.bgColor = "red"));
        check.action();
        hasValidationErrors = true;
      }
    });

    if (hasValidationErrors) return;

    // Add new question if validation passes
    const newQuestion = {
      ...createQuestionTemplate(),
      answerOptions: createAnswerOptions(),
    };

    setChaptCards((prev) => ({
      ...prev,
      questions: [...(prev.questions || []), newQuestion],
    }));
    setScrollFlag(true);
    scrollToLast();
  };

  const handleUpdateQuestion = (question: Question) => {
    console.log("entered update question in generate chapter edit");
    console.log("question options afdfadadfdfsadfs", question.answerOptions);
    let dt = { ...chaptCards };
    dt.questions?.map((ele, i) => {
      if (ele.quesId === question.quesId) {
        ele = question;
      }
      return ele;
    });
    setChaptCards(dt);
    console.log("chapt cards after update in gen chapters", chaptCards);
  };

  const handleDeleteQuestion = (quesId: string) => {
    let dt = { ...chaptCards };
    const index = dt.questions?.findIndex((ele, i) => ele.quesId === quesId);
    let data = dt?.questions?.filter((ele, i) => i !== index);
    dt.questions = data;
    setChaptCards(dt);
  };

  const chapterValidate = () => {
    let err: any = {};
    if (chaptCards.chapterName === "") {
      console.log("inside err of chapter");
      err.chapterName = {
        error: intl.formatMessage({
          id: "courses.generateChapterEdit.chapterNameAlert",
        }),
      };
      setErrors(err);
      return false;
    } else {
      return true;
    }
  };

  const chaptersUnchanged = (maybeUpdatedChapter?: CourseChapter): boolean => {
    const stableStringify = (value: any): string => {
      const seen = new WeakSet();
      const helper = (val: any): any => {
        if (val === null || typeof val !== "object") return val;
        if (seen.has(val)) return undefined;
        seen.add(val);
        if (Array.isArray(val)) return val.map((v) => helper(v));
        const sortedKeys = Object.keys(val).sort();
        const obj: any = {};
        for (const k of sortedKeys) obj[k] = helper(val[k]);
        return obj;
      };
      return JSON.stringify(helper(value));
    };
    const normalizeChapter = (chapter: CourseChapter) => {
      const cleaned = utils.deepCopy(chapter) as CourseChapter;

      // Remove transient chapter-level props
      (cleaned as any).newChapter = undefined;
      (cleaned as any).url = undefined;
      (cleaned as any).updatedAt = undefined;
      (cleaned as any).createdAt = undefined;
      (cleaned as any).date = undefined;

      // Clean cards and normalize order
      cleaned.cards = (cleaned.cards || [])
        .map((card: any) => {
          const c = { ...card } as any;
          c.url = undefined;
          c.updatedAt = undefined;
          c.createdAt = undefined;
          c.date = undefined;
          c.fileSize = undefined;
          c.fileCardName = undefined;
          c.seqNo = undefined;
          c.isLastCard = undefined;
          c.cardName = undefined;

          if (c.cardInfo && Array.isArray(c.cardInfo.card)) {
            c.cardInfo = {
              ...c.cardInfo,
              card: c.cardInfo.card.map((ci: any) => ({
                ...ci,
                tempUrl: undefined,
              })),
            };
          }
          return c;
        })
        .sort((a: any, b: any) =>
          String(a.cardId || "").localeCompare(String(b.cardId || ""))
        );

      // Clean questions if any and normalize order
      if (Array.isArray((cleaned as any).questions)) {
        (cleaned as any).questions = (cleaned as any).questions
          .map((q: any) => ({
            ...q,
            updatedAt: undefined,
            createdAt: undefined,
            date: undefined,
            bgColor: undefined,
          }))
          .sort((a: any, b: any) =>
            String(a.quesId || "").localeCompare(String(b.quesId || ""))
          );

        (cleaned as any).questions.forEach((q: any) => {
          if (Array.isArray(q.answerOptions)) {
            q.answerOptions = q.answerOptions
              .map((opt: any) => ({ ...opt }))
              .sort((a: any, b: any) =>
                String(a.optionId || "").localeCompare(String(b.optionId || ""))
              );
          }
        });
      }

      return cleaned;
    };

    const currentChapterId = (maybeUpdatedChapter?.chapterId ??
      chaptCards.chapterId) as string;
    const current =
      maybeUpdatedChapter ??
      props.course?.chapters?.find(
        (ch: CourseChapter) => ch.chapterId === currentChapterId
      );
    const baseline = props.copyCourse?.chapters?.find(
      (ch: CourseChapter) => ch.chapterId === currentChapterId
    );

    if (!current || !baseline) {
      // If we cannot find either side, treat as changed to avoid false skips
      return false;
    }

    const stripTransientFlags = (c: any) => {
      c.seqNo = undefined;
      c.isLastCard = undefined;
      c.isLastChapter = undefined;
      c.isTemprory = undefined;
      c.disabled = undefined;
      c.bgColor = undefined;
      return c;
    };

    const a = normalizeChapter(
      stripTransientFlags(utils.deepCopy(current)) as CourseChapter
    );
    const b = normalizeChapter(
      stripTransientFlags(utils.deepCopy(baseline)) as CourseChapter
    );

    const isSame = stableStringify(a) === stableStringify(b);
    console.log("chapter compare (current vs copy)", isSame);
    return isSame;
  };

  //proper functionality of quick save invoking
  async function quickSave(
    updatedChapter?: CourseChapter,
    forceAIVideoGenerating?: boolean
  ) {
    console.log("quick save function called!");
    console.log("Updated chapter details", updatedChapter);
    const currentAIVideoGenerating =
      forceAIVideoGenerating !== undefined
        ? forceAIVideoGenerating
        : aIVideoGenerating;
    console.log(
      "aIVideoGenerating inside quick save",
      currentAIVideoGenerating
    );

    if (chaptersUnchanged(updatedChapter) && !currentAIVideoGenerating) {
      console.log("No changes detected, skipping quick save");
      return;
    }

    setAIVideoGenerating(false);
    if (chapterValidate()) {
      // Create a copy of the course with the updated chapter
      let dt = utils.deepCopy(props.course);

      // If we have an updated chapter, replace it in the course
      if (updatedChapter) {
        const chapterIndex = dt.chapters.findIndex(
          (ch: CourseChapter) => ch.chapterId === updatedChapter.chapterId
        );
        if (chapterIndex !== -1) {
          dt.chapters[chapterIndex] = updatedChapter;
        }
      }

      // Clean up the course data
      dt.chapters.map((chpt: CourseChapter) => {
        delete chpt.newChapter;
        chpt.cards.map((card: any) => {
          delete card.cardInfo.card[0].tempUrl;
        });
      });

      console.log("course id before save draft", dt?.courseId);
      console.log("course before save draft", dt);

      if (props.specificCreateCourseFunction) {
        if (props.handleUpdateStatusAll) {
          if (dt && dt.status === "ARCHIVED") {
            console.log("inside if of archived course");
            props.handleUpdateStatusAll("DRAFT", dt);
          }
        }

        const saved = await props.specificCreateCourseFunction(dt);
        console.log("after quick save");

        console.log("This is the quick save boolean flag", saved);
        console.log("Setting quick save dialog to true");
        if (saved) {
          setCopyCourse(utils.deepCopy(dt));
          if (props.onQuickSaveSuccess) {
            // props.onQuickSaveSuccess()
            props.onQuickSaveSuccess(utils.deepCopy(dt));
          }
          console.log("Quick save success callback called");
        } else {
          console.log("Quick save failed, saved value:", saved);
        }
      }
    }
  }

  //testing new quick save working
  // async function quickSave(
  //   updatedChapter?: CourseChapter,
  //   forceAIVideoGenerating?: boolean
  // ) {
  //   console.log("quick save function called!");
  //   const currentAIVideoGenerating =
  //     forceAIVideoGenerating !== undefined
  //       ? forceAIVideoGenerating
  //       : aIVideoGenerating;

  //   if (chaptersUnchanged(updatedChapter) && !currentAIVideoGenerating) {
  //     console.log("No changes detected, skipping quick save");
  //     return;
  //   }

  //   setAIVideoGenerating(false);

  //   if (chapterValidate()) {
  //     let dt = utils.deepCopy(props.course);

  //     if (updatedChapter) {
  //       // ✅ Ensure cards are persisted with ordering
  //       const indexMap = cardArray.reduce<{ [key: string]: number }>(
  //         (map, card: { id?: string; cardId?: string }, index) => {
  //           const key = card.id || card.cardId;
  //           if (key) map[key] = index;
  //           return map;
  //         },
  //         {}
  //       );

  //       const sortedCards = [...updatedChapter.cards].sort(
  //         (a, b) => indexMap[a.cardId] - indexMap[b.cardId]
  //       );

  //       sortedCards.forEach((card, i) => {
  //         card.seqNo = i + 1;
  //         card.isLastCard = i === sortedCards.length - 1;
  //       });

  //       updatedChapter = {
  //         ...updatedChapter,
  //         cards: sortedCards,
  //       };

  //       // Replace chapter in course
  //       const chapterIndex = dt.chapters.findIndex(
  //         (ch: CourseChapter) => ch.chapterId === updatedChapter!.chapterId
  //       );
  //       if (chapterIndex !== -1) {
  //         dt.chapters[chapterIndex] = updatedChapter;
  //       }
  //     }

  //     // Cleanup temporary fields
  //     dt.chapters.forEach((chpt: CourseChapter) => {
  //       delete chpt.newChapter;
  //       chpt.cards.forEach((card: any) => {
  //         delete card.cardInfo.card[0].tempUrl;
  //       });
  //     });

  //     console.log("course before save draft", dt);

  //     if (props.specificCreateCourseFunction) {
  //       if (props.handleUpdateStatusAll && dt.status === "ARCHIVED") {
  //         props.handleUpdateStatusAll("DRAFT", dt);
  //       }

  //       const saved = await props.specificCreateCourseFunction(dt);
  //       if (saved) {
  //         setCopyCourse(utils.deepCopy(dt));
  //         props.onQuickSaveSuccess?.(utils.deepCopy(dt));
  //       }
  //     }
  //   }
  // }

  const handleCardUpdate = async (updatedCard: any) => {
    // Find the chapter this card belongs to
    const chapter = chaptCards;

    const updatedCards = chapter.cards.map((card: any) =>
      card.cardId === updatedCard.cardId ? updatedCard : card
    );

    const updatedChapter = {
      ...chapter,
      cards: updatedCards,
    };

    // Call quickSave with the full chapter
    await quickSave(updatedChapter, true);
  };

  const finalSave = () => {
    if (!chapterValidate()) return;

    if (!chaptCards?.questions) return;

    const questionsCopy = [...chaptCards.questions];
    console.log("final save being called");

    // Validation checks
    const hasEmptyQuestions = questionsCopy.some((quest) => !quest?.question);
    const hasEmptyOptions = questionsCopy.some((quest) =>
      quest.answerOptions.some((opt) => !opt.optionVal?.trim())
    );
    const hasInvalidAnswers = questionsCopy.some((quest) =>
      quest.answerOptions.every((opt) => opt.optionFlag !== "CORRECT")
    );

    // Handle question validations
    for (const question of questionsCopy) {
      if (!question.question) {
        setEmptyQuestionsDialog(true);
        question.bgColor = "red";
        return;
      }

      const hasEmptyOpt = question.answerOptions.some(
        (opt) => !opt.optionVal?.trim()
      );
      if (hasEmptyOpt) {
        setEmptyOptionsDialog(true);
        question.bgColor = "red";
        return;
      }

      const hasCorrectAnswer = question.answerOptions.some(
        (opt) => opt.optionFlag === "CORRECT"
      );
      if (!hasCorrectAnswer) {
        setQuestionOptionsDialog(true);
        question.bgColor = "red";
        return;
      }

      question.bgColor = "";
    }

    // Card validations
    for (const card of chaptCards.cards) {
      const isTextCard = card.cardInfo.cardType === "TEXT";
      const isLinkCard = card.cardInfo.cardType === "LINK";
      const cardText = card.cardInfo.card[0].text;
      const cardUrl = card.cardInfo.card[0].url;

      // Content validation
      if (
        (isTextCard && (!cardText || cardText === "<p></p>")) ||
        (!isTextCard && !cardUrl) ||
        (isLinkCard && !cardUrl)
      ) {
        setFormUserDialog(true);
        if (isLinkCard) setLinkValidation(true);
        else setLinkValidation(false);
        card.bgColor = "red";
        return;
      }

      // File size validation
      if (card.fileSize) {
        const fileSizeMB = card.fileSize / (1024 * 1024);

        if (card.cardType === "IMG" && fileSizeMB > 5) {
          setfileSizeDailog(true);
          setFileSizeImageValidation(true);
          setSizeError(true);
          card.bgColor = "red";
          return;
        }

        if (
          (card.cardType === "VIDEO" || card.cardType === "AUDIO") &&
          fileSizeMB > 16
        ) {
          setLargeFileSizeDialog(true);
          setSizeError(true);
          card.bgColor = "red";
          return;
        }
      }

      card.bgColor = "";
    }
    // Sort and update cards
    const indexMap = cardArray.reduce<{ [key: string]: number }>(
      (map, card: { id?: string; cardId?: string }, index) => {
        const key = card.id || card.cardId;
        if (key) {
          map[key] = index;
        }
        return map;
      },
      {}
    );

    const sortedCards = [...chaptCards.cards].sort(
      (a, b) => indexMap[a.cardId] - indexMap[b.cardId]
    );

    sortedCards.forEach((card, i) => {
      card.seqNo = i + 1;
      card.isLastCard = i === sortedCards.length - 1;
    });

    const updatedChapter = {
      ...chaptCards,
      cards: sortedCards,
    };

    setIsSave(true);

    // First update the chapter
    props.handleUpdateChapter(updatedChapter, true);
    console.log("Updated chapter data in final save", updatedChapter);

    // Then call quick save with the updated chapter data
    quickSave(updatedChapter);
  };
  useEffect(() => {
    if (firstTime === 0) {
      setFirstTime(1);
    } else {
      console.log("inside scroll left use effect");
      scrollToLeft();
      setScrollFlag(false);
    }
  }, [scrollFlag]);

  useEffect(() => {
    console.log("card array in use effect", cardArray);
    setCardArray(cardArray);
  }, [cardArray]);

  return (
    <div className="w-full rounded-2xl space-y-5 border border-mk-primary-bright pb-5 p-3 mb-5 relative">
      {loader && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20">
          <Loading />
        </div>
      )}

      <div className="hide-scroll w-full h-full flex justify-around items-center px-3">
        <div className="flex space-x-3 w-[45%] pr-2 justify-start items-center">
          <FontAwesomeIcon
            icon={["far", "fa-arrows-up-down-left-right" as IconName]}
            className="h-4 w-4 hover:cursor-move text-mk-primary-bright"
          />
          <div className="font-bold text-base">
            {`${intl.formatMessage({
              id: "courses.generatedChapterEdit.chapter",
            })}` + props.getIndex(chaptCards.chapterId)}
          </div>
          <div className="border border-mk-primary-bright flex justify-center items-center rounded-lg md:text-sm sm:text-[12px] px-0 bg-mk-primary-50">
            <Whisper
              placement="top"
              controlId="control-id-hover"
              speaker={chapterSpeaker}
              trigger="hover"
            >
              <div
                ref={chapterNameRef}
                className={`editable-div text-mk-very-dark-grey w-full font-bold text-sm ${
                  chptNameEdit
                    ? "bg-white"
                    : chaptCards.chapterName === ""
                    ? "p-3"
                    : ""
                }`}
                onBlur={() => setChptNameEdit(false)}
                onClick={() => setChptNameEdit(true)}
                contentEditable={chptNameEdit}
                onInput={handleUpdateChapterName}
              >
                {chaptCards.chapterName}
              </div>
            </Whisper>
          </div>
        </div>

        <div className="flex w-[55%] justify-end items-center space-x-5">
          <div className="font-bold">Micros</div>
          <Switch
            onLabel=""
            offLabel=""
            onChange={() => setToggle(!toggle)}
            size="small"
            trackRounded="full"
            thumbRounded="full"
            defaultChecked={toggle}
          />
          <div className="font-bold">
            {intl.formatMessage({
              id: "courses.generateChapterEdit.assessment",
            })}
          </div>

          <div className="flex items-center space-x-1">
            <div
              className={`rounded-full p-1.5 ${
                toggle ? "bg-mk-very-dark-grey" : "bg-mk-primary-bright"
              }`}
            />
            <div>
              {chaptCards.cards.length}
              {intl.formatMessage({
                id: "courses.generateChapterEdit.micros",
              })}
            </div>
          </div>

          <div className="flex items-center space-x-1">
            <div
              className={`rounded-full p-1.5 ${
                toggle ? "bg-mk-primary-bright" : "bg-mk-very-dark-grey"
              }`}
            />
            <div>
              {chaptCards.questions?.length}{" "}
              {intl.formatMessage({
                id: "courses.generateChapterEdit.assessment",
              })}
            </div>
            <FontAwesomeIcon
              icon={["far", "fa-arrows-repeat" as IconName]}
              className="fa-fw w-5 h-5 rotate-90 hover:text-mk-primary-bright hover:cursor-pointer text-mk-primary"
            />
          </div>

          <Whisper
            placement="top"
            controlId="control-id-hover"
            trigger="hover"
            speaker={
              hasEmptyUrl ? (
                // <Tooltip className="bg-mk-primary-bright text-white" >
                <Tooltip
                  className="bg-mk-primary text-black "
                  style={{ zIndex: 99999 }}
                >
                  <div>{`${intl.formatMessage({
                    id: "courses.generateChaptersCards.aiVideoGenerationInProgress",
                  })}`}</div>
                </Tooltip>
              ) : (
                delChapter
              )
            }
          >
            <FontAwesomeIcon
              icon={["far", "fa-trash" as IconName]}
              onClick={() => {
                if (!hasEmptyUrl) {
                  props.handleDelChapter(chaptCards);
                }
              }}
              className={`fa-fw w-4 h-4 ${
                hasEmptyUrl
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:cursor-pointer hover:text-mk-primary-bright"
              } text-mk-primary`}
            />
          </Whisper>

          {toggle ? (
            <Whisper
              placement="top"
              controlId="control-id-hover"
              trigger="hover"
              speaker={addNewAsmnt}
            >
              <FontAwesomeIcon
                icon={["fas", "fa-circle-plus" as IconName]}
                className="fa-fw w-6 h-6 hover:cursor-pointer hover:text-mk-primary-bright text-mk-primary"
                onClick={handleAddNewQuestion}
              />
            </Whisper>
          ) : (
            <Whisper
              placement="top"
              controlId="control-id-hover"
              trigger="hover"
              speaker={addNewCard}
            >
              <div>
                <MenuOptions options={addOption} onSelect={handleAddNewCard}>
                  <FontAwesomeIcon
                    icon={["fas", "fa-circle-plus" as IconName]}
                    className="fa-fw w-6 h-6 hover:cursor-pointer hover:text-mk-primary-bright text-mk-primary"
                  />
                </MenuOptions>
              </div>
            </Whisper>
          )}
        </div>
      </div>

      <div className="ml-4">
        <Error>{errors.chapterName?.error}</Error>
      </div>

      <div
        ref={containerLeft}
        className="p-5 border outlineCardHeight rounded-xl overflow-x-auto scroll-smooth bg-mk-primary-15 flex flex-row space-x-3"
      >
        {toggle ? (
          chaptCards.questions?.map((ele, i) => (
            <AssementCard
              key={i}
              maxCards={chaptCards.questions?.length!!}
              index={i}
              deleteQuestion={handleDeleteQuestion}
              updateQuestion={handleUpdateQuestion}
              lastQuestion={i === chaptCards.questions!!.length - 1}
              question={ele}
              showCardMenuBar={true}
            />
          ))
        ) : (
          <Sortable
            className="flex h-full w-screen"
            idField="cardId"
            disabledField="disabled"
            data={cardArray}
            itemUI={(e: SortableItemUIProps) => {
              const cardProps: CardComponentProps = {
                ...e,
                handleDuplicateCard: hanndleDuplicateCard,
                removeCard: handleRemoveCard,
                handleCardContentChange: handleUpdCardContentOfChpt,
                videoGeneratingCardIds: props.videoGeneratingCardIds,
                setVideoGeneratingCardIds: props.setVideoGeneratingCardIds,
                handleVideoGeneration: async (cards) => {
                  return await props.handleVideoGeneration(cards);
                },

                handleImageGeneration: async (cards) => {
                  setLoader(true);
                  const result = await props.handleImageGeneration(cards);
                  setLoader(false);
                  return result;
                },
                handleAudioGeneration: async (cards) => {
                  // Do not toggle parent loader for Test AI Audio to keep dialog mounted
                  if (props.handleAudioGeneration) {
                    return await props.handleAudioGeneration(cards);
                  }
                  return false;
                },

                handleSpecificCardUpdate: async (cards) => {
                  setLoader(true);
                  const urlFetchFromAPI = await props.handleUploadGiveUrl(
                    cards
                  );
                  setLoader(false);
                  return urlFetchFromAPI;
                },
                handleCardImageUpdate,
                handleCardVideoUpdate,
                handleGenVideoUrl,
                handleGenImageUrl,
                handleGenAudioUrl,
                handleCardAudioUpdate,
                handleCardTypeUpdate,
                handleFileTypeUpdate,
                maxCards: cardArray.length,
                showCardOptions: true,
                index: getIndex,
                enableDrag,
                handleEnableDrag: setEnableDrag,
                cards: props.course,
                generateUrl: async (courseId, filepath, cardId) => {
                  console.log("generate url in sortable", {
                    courseId,
                    filepath,
                    cardId,
                  });
                },
                quickSave: quickSave,
                handleCardUpdate: handleCardUpdate,
                chapterName: chaptCards.chapterName,
                aIVideoGenerating: aIVideoGenerating,
                setAIVideoGenerating: setAIVideoGenerating,
              };

              return (
                <CardComponent
                  key={(e as any)?.dataItem?.cardId || (e as any)?.cardId}
                  {...cardProps}
                />
              );
            }}
            onDragOver={onDragOver}
            onNavigate={onNavigate}
          />
        )}
      </div>

      <div className="w-full flex items-center justify-end pr-6 space-x-3">
        <Button
          themeColor="primary"
          onClick={() => props.handleUpdateChapter(initialChptCard, false)}
        >
          {intl.formatMessage({
            id: "users.cohortDisplay.cancel",
          })}
        </Button>
        <Button themeColor="primary" onClick={finalSave}>
          {intl.formatMessage({
            id: "user.cohortList.save",
          })}
        </Button>
      </div>

      {formUserDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "generateCard.errorValidation",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={okClick}
          />
        </Dialog>
      )}

      {fileSizeDailog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "generateCard.fileSizeImageErrorValidation",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={okfileSizeClick}
          />
        </Dialog>
      )}

      {largeFileSizeDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "generateCard.fileSizeErrorValidation",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={oklargeFileSizeClick}
          />
        </Dialog>
      )}

      {questionOptionsDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "courses.generatedChapterEdit.validOption",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={okquestionClick}
          />
        </Dialog>
      )}

      {showNoExistingQuestionDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "courses.generateChapterEdit.questionExistingCards",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={emptyquestionClick}
          />
        </Dialog>
      )}

      {emptyQuestionsDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "courses.generatedChapterEdit.enterQuestion",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={emptyquestionClick}
          />
        </Dialog>
      )}

      {emptyOptionsDialog && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: "courses.generatedChapterEdit.enterOptions",
            })}
            buttonText={intl.formatMessage({
              id: "users.buttonText.Ok",
            })}
            icon="errorShape.png"
            iconMsg={intl.formatMessage({ id: "iconMsgError" })}
            backgroundColor="mk-red"
            onClick={emptyoptionClick}
          />
        </Dialog>
      )}
    </div>
  );
}
